import { Grid, TextField } from "@mui/material";

import { ReactComponent as Calendar } from "../../../assets/icons/calendar.svg";
import DateRangePicker from "@mui/lab/DateRangePicker";
import { styled } from "@mui/system";
import { useFormikContext } from "formik";

const StyledTextField = styled(TextField)`
  & .MuiOutlinedInput-root {
    padding: 0;

    input {
      width: 100px;
    }

    input::placeholder {
      color: ${(props) => props.theme.palette.secondary.contrastText};
      opacity: 0.5;
    }

    & fieldset {
      border-color: ${(props) => props.theme.palette.secondary.main};
      background-color: transparent;
      border-width: 1px !important;
    }
  }
`;

const DateTimePicker = ({ range, name, ...props }) => {
  const { values, setFieldValue } = useFormikContext();
  // console.log(touched, errors, values);
  return (
    <Grid container spacing={1} alignItems="center" justifyContent="center">
      <Grid item xs={1}>
        <Calendar xs={{ height: "200px" }} />
      </Grid>
      <Grid item xs={11}>
        <DateRangePicker
          mask={"__/__/____"}
          startText="From"
          endText="To"
          value={[values["fromDate"], values["toDate"]]}
          onChange={(newValue) => {
            setFieldValue("fromDate", newValue?.[0]);
            setFieldValue("toDate", newValue?.[1]);
          }}
          renderInput={(startProps, endProps) => (
            <>
              <StyledTextField
                {...startProps}
                label=""
                size="small"
                InputLabelProps={{ shrink: false }}
              />

              <StyledTextField
                {...endProps}
                label=""
                size="small"
                InputLabelProps={{ shrink: false }}
                sx={{ ml: 2 }}
              />
            </>
          )}
        />
      </Grid>
    </Grid>
  );
};

export default DateTimePicker;
